export default "__VITE_ASSET__1MVxqXNS__"